module.exports = __webpack_public_path__ + "img/icon_map_8_off_100.554350b0.png";